import { emitCssVariables } from "@pws/coquille-config/browser";
import "@pws/coquille-app-shell/styles.css";
import "@pws/coquille-app-shell/readable-blocks.css";
import "@pws/coquille-app-shell/connected-shell.css";
import orignalPreset from "../presets/orignal.json";

const CONTRAST_OVERRIDE = `
:root {
  --text-on-dark: #f7f1e8;
  --og-text: #f7f1e8;
  --og-text-2: #e8dcc8;
  --og-link: #f4c57a;
}
.og-root, .og-root[data-surface="dark"], .og-home, .og-panel, .og-cockpit, .og-page {
  color: #f7f1e8;
}
.og-root h1, .og-root h2, .og-root h3,
.og-home h1, .og-home h2, .og-home h3,
.og-panel h1, .og-panel h2, .og-panel h3,
.og-home__hero h1, .og-home__hero p {
  color: #fff8ee !important;
}
.og-root a:not(.og-btn--primary):not(.og-tab.is-active):not(.og-chip.is-active),
.og-root a:link:not(.og-btn--primary),
.og-root a:visited:not(.og-btn--primary),
.og-home a:not(.og-btn--primary),
.og-home a:visited:not(.og-btn--primary) {
  color: #f4c57a !important;
}
.og-btn--primary, .og-home__phase, .og-badge:not(.og-badge--ghost) {
  color: #1a1612 !important;
}
`;

let injected = false;

export function injectCoquilleTokens() {
  if (injected || typeof document === "undefined") return;
  const style = document.createElement("style");
  style.setAttribute("data-coquille-bridge-tokens", "orignal2026");
  style.textContent = `${emitCssVariables(orignalPreset)}\n${CONTRAST_OVERRIDE}`;
  document.head.appendChild(style);
  injected = true;
}

export { orignalPreset };
